var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"charts-box"},[_c('qiun-vue-ucharts',{attrs:{"type":"area","opts":_vm.opts,"chartData":_vm.areaData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }